export const formatCPFOrCNPJ = (value) => {
  if (!value) return "";

  value = value.replace(/\D/g, "");

  // CPF
  if (value.length <= 11) {
    value = value.substring(0, 11);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return value;
  }

  // CNPJ
  value = value.substring(0, 14);
  value = value.replace(/^(\d{2})(\d)/, "$1.$2");
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
  value = value.replace(/(\d{4})(\d)/, "$1-$2");

  return value;
};

export const formatCPF = (value) => {
  if (!value) return "";

  const digitsOnly = value.replace(/\D/g, "").slice(0, 11);

  if (digitsOnly.length <= 3) return digitsOnly;
  if (digitsOnly.length <= 6) return digitsOnly.replace(/(\d{3})(\d+)/, "$1.$2");
  if (digitsOnly.length <= 9) return digitsOnly.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");

  return digitsOnly.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
};

export const formatPhone = (value) => {
  if (!value) return "";

  value = value.replace(/\D/g, "");

  value = value.substring(0, 11);

  if (value.length <= 10) {
    value = value.replace(/^(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
  } else {
    value = value.replace(/^(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");
  }

  return value;
};

export function normalizeEmail(email) {
  if (!email.includes("@")) return email;
  const username = email.split("@")[0];
  return `${username}.com`;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      const base64 = result.substring(result.indexOf(",") + 1);
      resolve(base64);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
